<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { carregarDadosIniciais } from "@/state/globalData";

export default {
  name: "App",
  mounted() {
    if (localStorage.getItem("userid")) {
      carregarDadosIniciais();
    }
  },
};
</script>

<style>
.custom-toast-card {
  background-color: #202328 !important;
}
</style>
